<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">会员等级配置管理·数据表格</h5>
        </a-col>
      </a-row>
    </template>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
          <a-form-item label="会员名称">
            <a-input v-model="dataForm.vip_name" placeholder="会员名称" />
          </a-form-item>
          <a-form-item label="APP展示">
            <a-select v-model="dataForm.isapp" allowClear style="width: 120px" placeholder="请选择">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="2">否</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增会员级别</a-button>
          </a-form-item>
        </a-form>

        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="vip_id"
          :loading="dataListLoading" :scroll="{ x: 1500 }">
          <template slot="department.department_name" slot-scope="department_name">
            <a-tag>{{ department_name }}</a-tag>
          </template>
          <template slot="vipBenefits" slot-scope="text, row">
            <a-button type="link" @click="showBenefitDetail(row)" :disabled="!row.vipBenefits || row.vipBenefits.length === 0">
              {{ row.vipBenefits ? row.vipBenefits.length : 0 }} 个权益
            </a-button>
          </template>
          <template slot="isapp" slot-scope="text">
            <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '是' : '否' }}</a-tag>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="setBenefitsHandle(row.vip_id)">
              设置权益
            </a-button>
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.vip_id)">
              编辑
            </a-button>
            <a-button type="link" class="btn-edit" @click="deleteHandle(row.vip_id)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    <setBenefits ref="setBenefits" @ok="getDataList"></setBenefits>
    <benefitDetail ref="benefitDetail"></benefitDetail>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
import setBenefits from "./components/setBenefits.vue";
import benefitDetail from "./components/benefitDetail.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
    setBenefits,
    benefitDetail,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/viplist/page",
        deleteURL: "/admin/viplist/delete",
      },
      dataForm: {
        vip_name: "",
        isapp: undefined,
      },
      columns: [
        {
          title: "会员名称",
          dataIndex: "vip_name",
          align: 'center',
          width: 200
        },
        {
          title: "价格",
          dataIndex: "vip_price",
          align: 'center',
          width: 200
        },
        {
          title: "原价",
          dataIndex: "vip_price2",
          align: 'center',
          width: 200
        },
        {
          title: "APP展示",
          dataIndex: "isapp",
          align: 'center',
          width: 100,
          scopedSlots: { customRender: "isapp" },
        },
        {
          title: "权益数量",
          dataIndex: "vipBenefits",
          align: 'center',
          width: 120,
          scopedSlots: { customRender: "vipBenefits" },
        },
        {
          title: "排序",
          dataIndex: "sort_order",
          align: 'center',
          width: 100
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          align: 'center',
          width: 300
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 300,
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    setBenefitsHandle(vipId) {
      this.$refs.setBenefits.init(vipId);
    },
    showBenefitDetail(row) {
      this.$refs.benefitDetail.init(row.vip_id, row.vip_name, row.vipBenefits);
    },
  },
};
</script>